if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => {
          this.removeAttribute('open');
          document.body.classList.remove(this.classes.show);
        };
      }

      get isLockingNeeded() {
        return FoxTheme.config.mqlMobile;
      }
    
      get requiresBodyAppended() {
        return FoxTheme.config.mqlMobile;
      }

      prepareToShow() {
        super.prepareToShow();

        this.card.classList.add('is-open');
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.card.classList.remove('is-open');
      }
    }
  );
}

if (!customElements.get('lookbook-card-wrapper')) {
  customElements.define(
    'lookbook-card-wrapper',
    class LookbookCardWrapper extends HTMLElement {
      constructor() {
        super();

        this.handleMediaClick = this.handleMediaClick.bind(this);
        this.handleMediaKeydown = this.handleMediaKeydown.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
      }

      get video() {
        return this.querySelector('video-element');
      }

      get media() {
        return this.querySelector('.lbcard__media');
      }

      get popupTrigger() {
        return this.querySelector('.lbcard__popup-btn-trigger');
      }

      connectedCallback() {
        if (this.media && this.popupTrigger) {
          this.media.addEventListener('click', this.handleMediaClick);
          this.media.addEventListener('keydown', this.handleMediaKeydown);
          this.media.addEventListener('pointerdown', this.handlePointerDown);
        }

        if (!this.video) return;

        this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
        this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
      }

      disconnectedCallback() {
        if (this.media) {
          this.media.removeEventListener('click', this.handleMediaClick);
          this.media.removeEventListener('keydown', this.handleMediaKeydown);
          this.media.removeEventListener('pointerdown', this.handlePointerDown);
        }
      }

      handlePointerDown(event) {
        this.pointerStart = {
          x: event.clientX,
          y: event.clientY,
        };
      }

      handleMediaClick(event) {
        const interactiveElement = event.target.closest('button, a, input, select, textarea, [aria-controls]');
        if (interactiveElement && interactiveElement !== this.media) return;

        if (this.pointerStart) {
          const movedX = Math.abs(event.clientX - this.pointerStart.x);
          const movedY = Math.abs(event.clientY - this.pointerStart.y);
          if (movedX > 8 || movedY > 8) return;
        }

        this.popupTrigger.click();
      }

      handleMediaKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        this.popupTrigger.click();
      }

      handleMouseInteraction(type, event) {
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
        }
      }
    }
  );
}
